import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { Decision_Type } from 'src/app/shared/models/decision_type';
import { Groupe_Politique } from 'src/app/shared/models/groupe_pol';
import { Place } from 'src/app/shared/models/place';
import { Signatures } from 'src/app/shared/models/signature';
import { TypePoint } from 'src/app/shared/models/type_point';
import { UrgenceLevel } from 'src/app/shared/models/urgence_level';
import { TypeSeance } from 'src/app/shared/models/type_seance';
import { Echevinat } from 'src/app/shared/models/echevinat';
import { Matieres } from 'src/app/shared/models/matieres';
import { Status_Objets } from 'src/app/shared/models/status_objet';
import { Groups, GroupsMembres } from 'src/app/shared/models/global/groups';
import { PointParameters } from 'src/app/shared/models/global/point-parameters';
import { Action_Statutes } from 'src/app/shared/models/actions_statutes';
import { IAppConfiguration } from 'src/app/shared/models/response/IAppConfiguration';
import { ModelesDocuments } from 'src/app/shared/models/modelesDocuments.model';
import { TemplateFusionChamps } from 'src/app/shared/models/global/template-fusion-champs';
import { ModelePoint } from 'src/app/shared/models/modele-point';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class IDelibeGlobalService {
    public apiBaseUrl: string;
    public headers: HttpHeaders;

    constructor(public http: HttpClient) {
      const config = JSON.parse(sessionStorage.getItem('globalConfig'));
      this.apiBaseUrl = config.apiGatewayBaseUrl + '/api/v1';
      this.headers = new HttpHeaders({
        'Content-Type': 'application/json',
      });
    }

  getGlobalTypesSeances(id?): Observable<TypeSeance[]> {
    if (id) {
      return this.http.get<TypeSeance[]>(`${this.apiBaseUrl}/Global/TypesSeances`, { params: { id: id } });
    } else {
      return this.http.get<TypeSeance[]>(`${this.apiBaseUrl}/Global/TypesSeances`);
    }
  }

  getGlobalEchevinat(): Observable<Echevinat[]> {
    return this.http.get<Echevinat[]>(`${this.apiBaseUrl}/Global/Echevinats`);
  }

  getGlobalGroupesPol(): Observable<Groupe_Politique[]> {
    return this.http.get<Groupe_Politique[]>(`${this.apiBaseUrl}/Global/GroupesPolitiques`);
  }

  getGroupes(): Observable<Groups[]> {
    return this.http.get<Groups[]>(`${this.apiBaseUrl}/Global/Groupes`);
  }

  getGlobalMatieres(): Observable<Matieres[]> {
    return this.http.get<Matieres[]>(`${this.apiBaseUrl}/Global/Matieres`);
  }

  getGlobalTypePoints(): Observable<TypePoint[]> {
    return this.http.get<TypePoint[]>(`${this.apiBaseUrl}/Global/TypesPoints`);
  }

  getGlobalUrgenceLevel(): Observable<UrgenceLevel[]> {
    return this.http.get<UrgenceLevel[]>(`${this.apiBaseUrl}/Global/NiveauxUrgences`);
  }

  getGlobalAllPointsStatuts(): Observable<Status_Objets[]> {
    return this.http.get<Status_Objets[]>(`${this.apiBaseUrl}/Global/StatutsPoints`);
  }

  getGlobalDecisionType(): Observable<Decision_Type[]> {
    return this.http.get<Decision_Type[]>(`${this.apiBaseUrl}/Global/TypesDecisions`);
  }

  getGlobalPointParameters(): Observable<PointParameters> {
    return this.http.get<PointParameters>(`${this.apiBaseUrl}/Global/Points/Parameters`);
  }

  getGlobalLieux(id?: number): Observable<Place[]> {
    if (id) {
      return this.http.get<Place[]>(`${this.apiBaseUrl}/Global/Lieux`, { params: { id: id } });
    } else {
      return this.http.get<Place[]>(`${this.apiBaseUrl}/Global/Lieux`);
    }
  }

  getGlobalSignature(): Observable<Signatures[]> {
    return this.http.get<Signatures[]>(`${this.apiBaseUrl}/Global/Signatures`);
  }

  // Retrive all action statutes
  getAllActionsStatutes(): Observable<Action_Statutes[]> {
    return this.http.get<Action_Statutes[]>(`${this.apiBaseUrl}/Global/Actions/Statutes`);
  }

  getAllActionsTypes(): Observable<{id: number; description: string}[]> {
    return this.http.get<{id: number; description: string}[]>(`${this.apiBaseUrl}/Global/Actions/Types`);
  }

    // Retrieve configuration (global parameters, etc.)
  getConfiguration(): Observable<IAppConfiguration> {
    return this.http.get<IAppConfiguration>(`${this.apiBaseUrl}/Global/Configuration`);
  }

  getGlobalModelesDoc(meetingIds?: number[], pointIds?: number[], onlyExtrait?: boolean, onlyiSign?: boolean, onlyCommon?: boolean): Observable<ModelesDocuments[]> {
    let params = new HttpParams();

    if (meetingIds && meetingIds.length > 0) {
      const seanceIds = meetingIds.join(',');
      params = params.append('seanceIds', seanceIds);
    }

    if (pointIds && pointIds.length > 0) {
      const pointIdsStr = pointIds.join(',');
      params = params.append('pointIds', pointIdsStr);
    }

    if (onlyExtrait) {
      params = params.append('onlyExtrait', onlyExtrait);
    }

    if (onlyiSign) {
      params = params.append('onlyiSign', onlyiSign);
    }

    if (onlyCommon) {
      params = params.append('onlyCommon', onlyCommon);
    }

    return this.http.get<ModelesDocuments[]>(`${this.apiBaseUrl}/Global/ModelesDocuments`, { headers: this.headers, params });
  }

  getGlobalFusionsFields(): Observable<TemplateFusionChamps> {
    return this.http.get<TemplateFusionChamps>(`${this.apiBaseUrl}/Global/Documents/Templates/FusionChamps`);
  }

  getGlobalModelesPoints(): Observable<ModelePoint[]> {
    return this.http.get<ModelePoint[]>(`${this.apiBaseUrl}/Global/ModelesPoints`);
  }

  getGlobalModelesPointsByIdsService(idsService: number[]): Observable<ModelePoint[]> {
    let params = new HttpParams();
    idsService.forEach(id => {
      params = params.append('serviceIds', id.toString());
    });

    return this.http.get<ModelePoint[]>(`${this.apiBaseUrl}/Global/ModelesPoints`, { headers: this.headers, params }).pipe(
      map((res: ModelePoint[]) => {
        return res;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }
  
  getGroupesMembresIDelibeSearch(groupsIds: number[]): Observable<GroupsMembres[]> {
    return this.http.get<GroupsMembres[]>(`${this.apiBaseUrl}/Global/GroupesMembres/Search`, {
      params: new HttpParams().set('GroupeIds', `${groupsIds}`),
    });
  }
}